<!--
 * @Author: chenguanbin
 * @Date: 2020-03-14 10:06:30
 * @Desc: 实时预警 - 审核弹出框
 -->
<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="visible"
    :area="1080"
    top="middle"
    no-scrollbar
    custom-class="realtime-warning-dialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @closed="closedDialog"
  >
    <div v-loading="loading" class="dialog-body">
      <div v-show="!loading" class="dialog-main">
        <dl v-if="eventDetail.hasImage">
          <dd>
            <img :src="eventDetail.alertImageUrl" />
          </dd>
          <dt class="image-tool-bar">
            <span>预警抓图</span>
            <i class="h-icon-zoom_in" @click="getImagePreview(eventDetail.alertImageUrl)" />
          </dt>
        </dl>
        <dl v-else-if="eventDetail.alertTypeCode === 'AIOP_AudioDetection'">
          <dd>
            <img :src="picAudio" />
          </dd>
          <dt class="image-tool-bar">
            <span>预警抓图</span>
            <i class="h-icon-zoom_in" @click="getImagePreview(picAudio)" />
          </dt>
        </dl>
        <div v-else class="temperature-warning">
          <p v-if="eventDetail.alertData">{{ eventDetail.alertData }}</p>
          <p>{{ eventDetail.alertTypeName }}</p>
        </div>
        <dl>
          <dd>
            <img
              v-if="eventDetail.afterProcessingImageUrl"
              :src="eventDetail.afterProcessingImageUrl"
            />
            <h-empty v-else size="xs" class="empty-image-wrap">
              <template #img>
                <h-empty-default-image />
              </template>
            </h-empty>
          </dd>
          <dt class="image-tool-bar">
            <span>
              {{ eventDetail.afterProcessingImageUrl ? '处置上传图片' : '企业未上传处理图片' }}
            </span>
            <i
              class="h-icon-zoom_in"
              @click="getImagePreview(eventDetail.afterProcessingImageUrl)"
            />
          </dt>
        </dl>
        <dl v-if="eventDetail.hasImage">
          <dd>
            <img v-if="captureImage" :src="captureImage" />
            <h-empty v-else size="xs" class="empty-image-wrap">
              <template #img>
                <h-empty-default-image />
              </template>
            </h-empty>
          </dd>
          <dt class="image-tool-bar">
            <span>实时抓图</span>
            <span style="display: flex;">
              <i class="h-icon-refresh refresh-capture" @click="getCaptureImage" />
              <i class="h-icon-zoom_in" @click="getImagePreview(captureImage)" />
            </span>
          </dt>
        </dl>
        <div v-if="!isCommentDisabled" class="review-idea">
          <span>审核意见</span>
          <el-input v-model="reviewIdea" type="textarea" :maxlength="256" />
        </div>
      </div>
      <div v-show="!loading" class="dialog-aside">
        <HistoryWarningAside inner-dialog :event-detail="eventDetail" :visible="visible" />
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button
        :disabled="isDisabled"
        class="page-btn"
        type="primary"
        @click="dealWarningEvent(1)"
      >
        通过
      </el-button>
      <el-button :disabled="isDisabled" class="page-btn" @click="dealWarningEvent(0)">
        退回
      </el-button>
      <el-button class="page-btn" @click="closeDialog">关闭</el-button>
    </div>
    <h-img-preview :data="previewImageUrl" :visible.sync="imagePreviewShow" />
  </el-dialog>
</template>

<script>
import HistoryWarningAside from './HistoryWarningAside'
import http from '@/api/warningManage.api'
import picAudio from '@/assets/images/realtimeWarning/pictureL.png'

export default {
  name: 'WarningDialog',
  components: { HistoryWarningAside },
  props: {
    isDisabled: {
      type: Boolean,
      required: true
    },
    isCommentDisabled: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      picAudio,
      visible: false,
      loading: false,
      alertEventId: '',
      reviewIdea: '',
      eventDetail: {},
      captureImage: '',
      previewImageUrl: [],
      imagePreviewShow: false
    }
  },
  computed: {
    dialogTitle() {
      return this.eventDetail.enterpriseDetail
        ? this.eventDetail.enterpriseDetail.enterpriseName
        : ''
    }
  },
  watch: {
    // alertEventId(value) {
    //   value && this.getWarningEventDetail()
    // }
  },
  methods: {
    openDialog(alertEventId) {
      this.loading = true
      this.visible = true
      this.alertEventId = alertEventId
      this.getWarningEventDetail()
    },
    closeDialog() {
      this.visible = false
      this.$emit('dialogClose')
    },

    /**
     * @author xuchen
     * @date 2020-06-03 11:30:47
     * @desc 弹窗完全关闭后
     */
    closedDialog() {
      this.reviewIdea = ''
      this.captureImage = ''
      this.eventDetail = {}
    },

    /**
     * @Author: maogangfeng
     * @Date: 2020-03-19 15:59:12
     * @Desc: 获取预警事件详情
     */
    async getWarningEventDetail() {
      const { data } = await http.getWarningEventDetail({
        alertEventId: this.alertEventId
      })
      this.eventDetail = data
      this.loading = false
      if (this.eventDetail.hasImage) {
        this.getCaptureImage()
      }
    },
    /**
     * @Author: maogangfeng
     * @Date: 2020-03-19 15:59:01
     * @Desc: 获取实时抓拍
     */
    async getCaptureImage() {
      const { data } = await http.getCaptureImage({
        channelNo: this.eventDetail.channelNo,
        deviceSerial: this.eventDetail.deviceSerial,
        projectId: this.$store.state.projectCode
      })
      this.captureImage = data
    },
    async dealWarningEvent(isPassed) {
      const params = {
        alertEventId: this.alertEventId,
        comment: this.reviewIdea,
        isPassed: isPassed,
        projectCode: this.$store.state.projectCode
      }
      !isPassed && (params.imageUrl = this.captureImage)
      const { code } = await http.dealWarningEvent(params)
      if (code === '200') {
        this.closeDialog()
      }
    },
    /**
     * @Author: maogangfeng
     * @Date: 2020-04-08 16:47:31
     * @Desc: 图片大图预览
     */
    getImagePreview(image) {
      if (image) {
        this.previewImageUrl = [image]
        this.imagePreviewShow = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-body {
  display: flex;
  width: 100%;
  height: 460px;
}
.dialog-main {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  &::after {
    content: '';
    position: absolute;
    top: -12px;
    bottom: -12px;
    right: 0;
    width: 1px;
    background-color: rgba(0, 0, 0, 0.12);
  }
  dl {
    width: 50%;
    height: 216px;
    padding-right: 12px;
    &:first-child,
    &:nth-child(2) {
      margin-bottom: 12px;
    }
  }
  dd {
    height: 184px;
    img {
      width: 100%;
      height: 100%;
      background-color: #666;
      object-fit: contain;
      object-position: center;
    }
    .empty-image-wrap {
      background: rgba(0, 0, 0, 0.04);
    }
  }
  dt {
    height: 32px;
    line-height: 32px;
    padding: 0 8px;
    background-color: #333;
    color: rgba(255, 255, 255, 0.7);
  }
  .image-tool-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    i {
      margin-left: 8px;
      font-size: 24px;
      cursor: pointer;
    }
  }
  .temperature-warning {
    width: 221px;
    height: 252px;
    margin-right: 30px;
    background-image: linear-gradient(135deg, #f4915f 0%, #ffd194 100%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    p:first-child {
      font-size: 36px;
      color: #ffffff;
    }
    p:last-child {
      font-size: 18px;
      color: rgba(255, 255, 255, 0.7);
    }
  }
  .temperature-warning + dl {
    width: 60%;
    height: 251px;
    dd {
      height: 220px;
    }
  }
  .review-idea {
    width: 50%;
    padding-right: 12px;
    span {
      display: block;
      height: 32px;
      line-height: 32px;
      color: rgba(0, 0, 0, 0.7);
    }
    .el-textarea {
      height: calc(100% - 32px);
    }
    ::v-deep .el-textarea__inner {
      height: 100%;
    }
  }
}
.dialog-aside {
  flex: none;
  width: 380px;
}
</style>
